import { GroupData } from '@bringg/types';

import useOrderExplorerStore from '../../order-explorer/stores/use-order-explorer-store';
import { orderExplorerRootStore } from '../../order-explorer/stores/order-explorer-root-store';
import { orderExplorerGroupLoader } from 'bringg-web/features/monitoring/order-explorer/data/order-explorer-group-loader';

export const useViewableGroups = (group: GroupData) => {
	const {
		ordersMapStore: { markersToViewOnMap, setMarkersToViewOnMap },
		orderExplorerStore
	} = useOrderExplorerStore();

	const isItemViewable = (): boolean => {
		return group.group_type !== 'team';
	};

	const allTasksInView = (groupId: string): boolean => {
		const groupTasks = orderExplorerStore.currentTableDefinition.itemsByGroup[groupId];
		return groupTasks?.every(task => markersToViewOnMap.has(task.id));
	};

	const isInView = (): boolean => {
		let selectedItems = 0;
		let totalItemsCount = 0;
		if (group.groups) {
			selectedItems = group.groups.filter(innerGroup => allTasksInView(innerGroup.id)).length;
			totalItemsCount = group.groups.length;
		} else {
			const groupTasks = orderExplorerStore.currentTableDefinition.itemsByGroup[group.id];
			selectedItems = (groupTasks || []).filter(task => markersToViewOnMap.has(task.id)).length;
			totalItemsCount = groupTasks?.length || 0;
		}
		return selectedItems > 0 && selectedItems === totalItemsCount;
	};

	const setRoutesDirections = async (isChecked: boolean) => {
		await orderExplorerRootStore.getStore().ordersMapStore.toggleRouteOnMap(group.data.id, group.id, isChecked);
	};

	const viewGroup = async (isChecked: boolean) => {
		if (!isChecked) {
			const ids = orderExplorerStore.currentTableDefinition.itemsByGroup[group.id].map(item => item.id);
			setMarkersToViewOnMap(ids, false);
			setRoutesDirections(false);
			return;
		}

		const items = await orderExplorerGroupLoader.load(group);

		if (group.group_type === 'route' && !!group.data.id) {
			await setRoutesDirections(isChecked);
		}

		setMarkersToViewOnMap(
			items.map(({ id }) => id),
			isChecked
		);
	};

	return {
		isItemViewable: isItemViewable(),
		isInView: isInView(),
		viewGroup
	};
};
